export default __webpack_public_path__ + "images/battle-submarine.png";